var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorror(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87102 20.5421V21.2985M8.87102 21.2985C8.87102 22.3398 8.17062 23 7.30663 23C6.44264 23 5.74224 22.3398 5.74224 21.2985V18.5674C6.10569 16.4866 1.77905 16.6236 1.77905 10.012C1.77905 5.03481 6.35516 1 12.0001 1C17.645 1 22.2211 5.03481 22.2211 10.012C22.2129 16.6522 17.89 16.419 18.2579 18.7069V20.2388V21.2985C18.2579 22.3398 17.5575 23 16.6935 23C15.8295 23 15.129 22.3398 15.129 21.2985M8.87102 21.2985C8.87102 22.3398 9.57167 23 10.4357 23C11.2996 23 12 22.3398 12 21.2985M12 20.5421V21.2985M12 21.2985C12 22.3398 12.7006 23 13.5646 23C14.4286 23 15.129 22.3398 15.129 21.2985M15.129 20.5421V21.2985M12.2838 15.4507C13.0287 15.4507 13.3473 16.3461 13.5646 17.1706C13.6281 17.4117 13.3641 17.5627 13.14 17.4475C12.7191 17.2311 12.6623 17.1243 12.2838 17.1301M12.2838 15.4507C11.534 15.4507 11.2133 16.3418 11 17.1706C10.9387 17.4087 11.1973 17.5605 11.4196 17.4494C11.8572 17.2307 11.9177 17.1357 12.2838 17.1301M12.2838 15.4507V17.1301M18.5 10.7342C18.5 6.88869 13.5646 6.88869 13.5646 10.7342C13.5646 14.523 18.5 14.523 18.5 10.7342ZM10.4357 10.7342C10.4357 6.88869 5.5 6.88869 5.5 10.7342C5.5 14.523 10.4357 14.523 10.4357 10.7342Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorror);
export default __webpack_public_path__ + "static/media/horror.bdba7bf5024f8b4a38b002a42812a863.svg";
export { ForwardRef as ReactComponent };